import React from "react";
import Navbar from "./Navbar";

import "./Login.css";
const Home = () => {
  return (
    <div className="HomeNav">
      <div className="navtop">
        <Navbar />
      </div>
      <div className="Home">
        <h1>Welcome to React</h1>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipus fugit
          perspiciatiisicing Lorem ipsum dolor sit, amet consectetur adipus
          fugit perspiciatiisicing elit. Ullam eumiatiisicing elit. Ullam eum
          harum totam sint rem. Natus{" "}
        </p>
        <p>
          debitis dolorum deleniti similique vel in est facere, nemo, enim illo
          Lorem ipsum dolor sit,iatiisicing elit. Ullam eUllam ffbreeum amet
          consectetur adipus fugiticing eius tempora harum. Id delects eaque
          assumenda{" "}
        </p>
        <p>
          cumque porro et consectetur, vitae velit non odio eost non odio eos t
          non odio eos. dignissimos rerum corporis asperiores enim facere natus
          possnim facere natus pnim facere natus pimus ipsa ea voluptatibus al.
        </p>
        <p>
          cumque porro et consectetur, vitae velit non odio eos dignissimos
          asperiores enim facere natus possim rerum
        </p>
        <button>Explore More !!!</button>
      </div>
    </div>
  );
};

export default Home;
